import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `ValidacionMateriaPrima/getPoolsMateriaPrima`, method: 'POST', body: list, token: token})
}